'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFunction = function isFunction(options) {
  return typeof options === 'function';
};

// IE11 symbols are just normal properties and don't need this to get picked up
var getOwnPropertySymbols = Object.getOwnPropertySymbols || function () {
  return [];
};

exports.default = function (options) {
  if (_enviro2.default.deployed('hub-http') || !Object.freeze) return options;

  Object.freeze(options);
  Object.getOwnPropertyNames(options).concat(getOwnPropertySymbols(options)).forEach(function (name) {
    if (isFunction(options) && name !== 'caller' && name !== 'callee' && options[name] != null && !Object.isFrozen(options[name])) {
      Object.freeze(options[name]);
    }
  });
  return options;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.117/js/helpers/freeze.js
// module id = 166
// module chunks = 0 1